<template>
        <div>
            <app-list-produkte-item id="elem" class="col-6" v-for="item in list"
                                      :item="item"></app-list-produkte-item>
        </div>
</template>

<script>
  import ListProdukteItem from './ListProdukteItem'
  import data from '../../data/products'

  export default {
    data () {
      return {
        list: data
      }
    },
    components: {
      appListProdukteItem: ListProdukteItem
    }
  }
</script>

<style lang="scss" scoped>
    @import '../../styles/app';
    div {
        display: inline-block;
    }
    #elem {
        margin-bottom: 20px;
    }
    div:nth-child(even) {
        float:right;
    }
</style>

